(() => {
  if (window.__nnChapterTwoShopLoaded) return;
  window.__nnChapterTwoShopLoaded = true;

  const desktop = window.matchMedia('(min-width: 990px)');
  let wrapper;
  let productMarker;
  let chapterMarker;

  const findSections = () => ({
    productSection: document.querySelector('[id$="__product_list_fjjQTj"]'),
    chapterSection: document.querySelector('section[id$="__hero_8mzDbi"]')
  });

  const addAssurance = (commerceWrapper) => {
    if (!commerceWrapper || commerceWrapper.querySelector('.nn-chapter-two-shop__assurance')) return;

    const assurance = document.createElement('div');
    assurance.className = 'nn-chapter-two-shop__assurance';
    assurance.setAttribute(
      'aria-label',
      'Choose three country charms and let the fourth be our gift. £23 per country charm. Complimentary UK Delivery on Bag & Charm Orders. 12 Month Warranty. 90-day returns.'
    );
    assurance.innerHTML =
      '<div class="nn-chapter-two-shop__track">' +
        '<span class="nn-chapter-two-shop__message">Choose three country charms and let the fourth be our gift <b>◆</b> £23 per country charm <b>◆</b> Complimentary UK Delivery on Bag &amp; Charm Orders <b>◆</b> 12 Month Warranty <b>◆</b> 90-day returns <b>◆</b></span>' +
        '<span class="nn-chapter-two-shop__message" aria-hidden="true">Choose three country charms and let the fourth be our gift <b>◆</b> £23 per country charm <b>◆</b> Complimentary UK Delivery on Bag &amp; Charm Orders <b>◆</b> 12 Month Warranty <b>◆</b> 90-day returns <b>◆</b></span>' +
      '</div>';
    commerceWrapper.appendChild(assurance);
  };

  const mount = () => {
    if (location.pathname !== '/' || !desktop.matches || wrapper?.isConnected) return;

    const { productSection, chapterSection } = findSections();
    if (!productSection || !chapterSection) return;

    productMarker ||= document.createComment('North & Noble charm collection position');
    chapterMarker ||= document.createComment('North & Noble Chapter 02 position');

    if (!productMarker.isConnected) productSection.before(productMarker);
    if (!chapterMarker.isConnected) chapterSection.before(chapterMarker);

    wrapper = document.createElement('div');
    wrapper.className = 'nn-chapter-two-commerce';
    wrapper.setAttribute('aria-label', 'Chapter 02 — Collect Your Places');
    chapterMarker.after(wrapper);
    wrapper.append(chapterSection, productSection);
    addAssurance(wrapper);
  };

  const unmount = () => {
    if (!wrapper?.isConnected) return;

    const { productSection, chapterSection } = findSections();
    if (chapterSection && chapterMarker?.isConnected) chapterMarker.after(chapterSection);
    if (productSection && productMarker?.isConnected) productMarker.after(productSection);
    wrapper.remove();
    wrapper = undefined;
  };

  const sync = () => {
    if (desktop.matches) mount();
    else unmount();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  desktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
